import { GameVars } from "./GameVars";
import { GameConstants } from "./GameConstants";
import { GameManager } from "./GameManager";

    export class Boot extends Phaser.State {

        public static currentInstance: Boot;

        private hasLoaded: boolean = false;
        
        public init(): void {

            Boot.currentInstance = this;
        }
        
        public create(): void {

            //  Unless you specifically need to support multitouch I would recommend setting this to 1
            this.input.maxPointers = 1;

            //  Phaser will automatically pause if the browser tab the game is in loses focus. You can disable that here:
            this.game.stage.disableVisibilityChange = false;

            // por el problema del stock browser
            this.game.stage.backgroundColor =  "#000000";

            if (window.innerHeight > window.innerWidth || this.game.device.desktop) {
                this.initGame();
                document.getElementById("orientation").style.display = "none";
            } else {
                document.getElementById("orientation").style.display = "block";
            }

            if (!this.game.device.desktop) {
                this.game.scale.forceOrientation(false, true);
                this.game.scale.enterIncorrectOrientation.add(this.enterIncorrectOrientation, this);
                this.game.scale.leaveIncorrectOrientation.add(this.leaveIncorrectOrientation, this);
            }
        }

        private initGame(): void {
            this.hasLoaded = true;

            if (this.game.device.desktop) {

                GameVars.scaleY = 1;
                GameVars.fieldCorrectionScaleY = 1;
                
                this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
                this.game.scale.pageAlignHorizontally = true;

            } else {

                this.game.scale.scaleMode = Phaser.ScaleManager.EXACT_FIT;

                GameVars.aspectRatio = window.innerHeight / window.innerWidth;
                
                GameVars.scaleY = (4 / 3) / GameVars.aspectRatio;

                if (GameVars.aspectRatio < 1.45) {
                    GameVars.fieldCorrectionScaleY = 1;
                } else if (GameVars.aspectRatio < 1.55) {
                    GameVars.fieldCorrectionScaleY = 1.075; 
                } else {
                    GameVars.fieldCorrectionScaleY = 1.1;
                }

                this.game.scale.pageAlignHorizontally = true;
                this.game.scale.pageAlignVertically = true;
            }

            this.game.renderer.clearBeforeRender = false;

            if ( GameConstants.DEVELOPMENT ) {
                this.game.time.advancedTiming = true;
            }

            this.game.physics.startSystem( Phaser.Physics.P2JS );
            this.game.physics.p2.gravity.y = 1300;
            this.game.physics.p2.setBoundsToWorld( false, false, false , false);

            // el juego en safari modo privado no funciona
            if (this.game.device.safari && !this.isLocalStorageNameSupported()) {
                alert("This game uses local storage. It doesn't support private browsing");
            }

            GameVars.getInstance().init(this.game);            
            GameManager.init(this.game);
        }

        private isLocalStorageNameSupported(): boolean {

            const testKey = "test";
            let storage = window.sessionStorage;
            try {
                storage.setItem(testKey, "1");
                storage.removeItem(testKey);
                return true;
            } catch (error) {
                return false;
            }
        }
        
        private enterIncorrectOrientation(): void {

            document.getElementById("orientation").style.display = "block";
        }

        private leaveIncorrectOrientation(): void {

            document.getElementById("orientation").style.display = "none";
            if (!this.hasLoaded) {
                this.initGame();
            }
        }
    }
